require('./resources/sass/styles.scss');

// require('./resources/js/jquery-global');
// require('popper.js');
// require('bootstrap');
require('./resources/js/jquery-template');

// require('./resources/js/lwsreviews-global');
require('./resources/js/lwsreviews-feed');  